/* eslint-disable @typescript-eslint/naming-convention */
import {Entity} from 'app/core/main.entity';
import {Type} from 'class-transformer';
import 'reflect-metadata';
import {AppColorList, AppIconsList, AppWidthList, BlockElementImageSizeList, BlockElementType, BlockSettingsAlignmentList} from '../enums';
import {File} from '../file.entity';
import {BlockElement, BlockElementSettings} from './blockElement';
import {BlockElementIcon} from './blockElementIcon';
import {BlockAction} from './blockAction';

export class BlockElementImage extends BlockElement {
  type?: BlockElementType = 'image';

  @Type(() => BlockElementImageBackground)
  background?: BlockElementImageBackground = null;

  @Type(() => BlockElementImageSettings)
  settings?: BlockElementImageSettings = new BlockElementImageSettings();

  @Type(() => BlockElementIcon)
  icon?: BlockElementIcon = null;

  @Type(() => BlockAction)
  action?: BlockAction = null;
}

export class BlockElementImageBackground extends Entity {
  icon?: AppIconsList = null;

  @Type(() => File)
  image?: File = null;

  background?: AppColorList = null;
}

export class BlockElementImageSettings extends BlockElementSettings {
  size?: BlockElementImageSizeList = 'small';
  width?: AppWidthList = 'inline';
  alignment?: BlockSettingsAlignmentList = 'left';
}
